import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: config.sentryDsn,
  integrations: [

  ],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId={config.googleAuthClientId}>
        <App />
    </GoogleOAuthProvider>
);

//TODO: check this shit
reportWebVitals();